<template>
  <logged-in-layout>
    <main>
      <header :class="$style.header">
        <router-link to="/">Recordings</router-link>
        <router-link v-if="user.crmRequired" to="/tasks">Log Activity</router-link>
        <router-link to="/focus">Focus</router-link>
      </header>
      <router-view :is-rep="isRep"></router-view>
    </main>
  </logged-in-layout>
</template>

<script>
import store from '@/lib/store'
import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'

export default {
  components: {
    LoggedInLayout
  },
  data () {
    return {
      user: store.get('user')
    }
  },
  computed: {
    isRep () {
      return this.user.roles.find((role) => role.name === 'user')
    }
  }
}
</script>

<style module lang="less" src="./Home.less"></style>



// WEBPACK FOOTER //
// Home.vue?cc999096